import { jsx as o } from "react/jsx-runtime";
import { useBreakpointValue as i } from "@chakra-ui/react";
import { Link as l } from "../Link/Link.mjs";
const a = ({ children: t, ...e }) => {
  const r = i({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ o("span", { role: "listitem", children: /* @__PURE__ */ o(l, { ...r && { width: "fit-content" }, ...e, children: t }) });
};
export {
  a as GlobalFooterLink
};
